import type { IAdapterConfig, MiddlewareConfigClass } from '@care-portals/api-interfaces';

const config = {
  rxVortex: {
    label: 'RxVortex',
    functions: {
      CreateOrder: {
        middlewareHandler: 'rx-vortex',
        version: 2,
        label: 'Create standalone Rx Vortex order',
        pipelines: ['order'],
        passPayload: true,
        params: []
      },
      HandleWebhook: {
        middlewareHandler: 'rx-vortex',
        version: 2,
        label: 'Handle Webhook',
        pipelines: ['webhook'],
        passPayload: true,
        params: []
      }
    }
  }
} as const;

export const RxVortexConfig: IAdapterConfig = {
  ...config
} as unknown as IAdapterConfig;

export type RxVortexFunctionConfiguration = MiddlewareConfigClass<
  typeof config.rxVortex.functions
>;
